import { render, staticRenderFns } from "./SrReportTwdb.vue?vue&type=template&id=ffeaa9aa&"
import script from "./SrReportTwdb.vue?vue&type=script&lang=js&"
export * from "./SrReportTwdb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports